import { formatPrice } from '@payaca/helpers/financeHelper';
import { CurrencyValue as TCurrencyValue } from '@payaca/types/currencyTypes';
import { FC } from 'react';

type Props = TCurrencyValue & {
  /** Show £7,500 rather than £7,500.00, but still £7,500.50. */
  hideZeroMinorUnits?: boolean;
};

const CurrencyValue: FC<Props> = (props) => {
  const { value, currency, hideZeroMinorUnits } = props;

  const f = formatPrice(
    navigator.language,
    hideZeroMinorUnits ? { trailingZeroDisplay: 'stripIfInteger' } : {}
  );

  return (
    <>
      {f({
        priceInMinorCurrencyUnits: value,
        exponent: currency.exponent,
        currencyCode: currency.code,
      })}
    </>
  );
};

export default CurrencyValue;
